import { AppStore, getUserProfile, SetUserProfileAction } from '@alfresco/aca-shared/store';
import { ProfileState } from '@alfresco/adf-extensions';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { GROUP_ADMINISTRATION_SITE_MANAGER, GROUP_BOUD_SITE, GROUP_LOANS_SITE, GROUP_RECORDS_SITE, GROUP_TRANSFER_CALENDAR_SITE, GROUP_TRANSFERS_SITE } from '../../model/contants/deusto';
import { isInGroup } from 'projects/alden-extension/src/lib/rules/alden.rules';
import { UdeuService } from '../../services/udeu.service';
import { Group, GroupEntry, Person } from '@alfresco/js-api';
import { GroupService } from '@alfresco/adf-content-services';

@Component({
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class UDeuHomeComponent implements OnInit {
  profile$: Observable<ProfileState>;

  /** Path to a custom background image. */
  @Input()
  backgroundImageUrl: string = 'assets/deusto-extension/images/deusto-archivo-historico-2.jpeg';
  linearGradient: string = 'rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)';

  canBoud: boolean;
  canLoans: boolean;
  canTransferCalendar: boolean;
  canTransfers: boolean;
  canRecords: boolean;
  canAdministration: boolean;

  isInGroup : (profile: ProfileState, groupId: string) => boolean;

  loading: boolean;
  loginAttempts: number;
  loadedProfile: boolean;

  constructor(
    private router: Router,
    private store: Store<AppStore>,
    private udeuService: UdeuService,
    private groupService: GroupService
  ) {
    this.profile$ = this.store.select(getUserProfile);
    this.isInGroup = isInGroup;
    this.loginAttempts = 0;
  }

  ngOnInit(): void {
    this.loading = true;

    this.profile$.subscribe((profile) => {
      if(profile && profile.id) {
        this.canBoud = isInGroup(profile, GROUP_BOUD_SITE);
        this.canLoans = isInGroup(profile, GROUP_LOANS_SITE);
        this.canTransferCalendar = isInGroup(profile, GROUP_TRANSFER_CALENDAR_SITE);
        this.canTransfers = isInGroup(profile, GROUP_TRANSFERS_SITE);
        this.canRecords = isInGroup(profile, GROUP_RECORDS_SITE);
        this.canAdministration = isInGroup(profile, GROUP_ADMINISTRATION_SITE_MANAGER);

        /*console.debug("HE OBTENIDO EL PERFIL", profile);
        if(!this.loadedProfile) {
          this.getPersonDetails(profile);
        }*/
        this.loading = false;  // Eliminar si se descomenta lo de arriba
      }
    });
  }

  getPersonDetails(profile?: ProfileState) {
    // Si es admin o se ha superado el máximo de intentos
    if(profile?.isAdmin || this.loginAttempts >= 3) {
      this.loading = false;
      return;
    }

    this.loginAttempts++;
    this.udeuService.getPersonDetails(true).then((person) => {
      console.debug("DETALLES DE LA PERSONA", person);
      if(person.capabilities?.isAdmin || person.company?.organization === "KC") {
        this.loadUserProfile(person);
        this.loading = false;
      } else {
        setTimeout(() => {
          this.getPersonDetails();
        }, 2000); // Espera de 2 segundos
      }
    });
  }

  private async loadUserProfile(person: Person) {
    const groupsEntries: GroupEntry[] = await this.groupService.listAllGroupMembershipsForPerson('-me-', { maxItems: 250 }).then((groups) => {
      console.debug("GROUPS", groups);
      return groups;
    });
    const groups: Group[] = [];
    if (groupsEntries) {
      groups.push(...groupsEntries.map((obj) => obj.entry));
    }
    this.loadedProfile = true;
    this.store.dispatch(new SetUserProfileAction({ person: person, groups }));
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }
}